import {createRouter, createWebHistory} from 'vue-router'
import HomePage from '../components/HomePage.vue'
import LoginPage from '../components/LoginPage.vue'
import RegisterPage from '../components/RegisterPage.vue'
import AccountPage from '../components/AccountPage.vue'
import LogoutPage from '../components/LogoutPage.vue'
import OrganisationPage from "@/components/OrganisationPage.vue";
import ForbiddenPage from "@/components/ForbiddenPage.vue";
import NotFoundPage from "@/components/NotFoundPage.vue";
import OrganisationAdminPage from "@/components/OrganisationAdminPage.vue";
import OrganisationUserShiftsAdminPage from "@/components/OrganisationUserShiftsAdminPage.vue";
import OrganisationUsersAdmin from "@/components/OrganisationUsersAdmin.vue";
import ResetPasswordPage from "@/components/ResetPasswordPage.vue";
import ConfirmPasswordResetPage from "@/components/ConfirmPasswordResetPage.vue";
import OrganisationUserAdmin from "@/components/OrganisationUserAdmin.vue";
import OrganisationRolesAdmin from "@/components/OrganisationRolesAdmin.vue";
import AboutPage from "@/components/AboutPage.vue";
import OrganisationDownloadDataPage from "@/components/OrganisationDownloadDataPage.vue";
import OrganisationGoodiesAdmin from "@/components/OrganisationGoodiesAdmin.vue";
import OrganisationUserGoodiesAdmin from "@/components/OrganisationUserGoodiesAdmin.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            title: 'MyCrew',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: {
            title: 'Login',
        },
    },
    {
        path: '/logout',
        name: 'logout',
        component: LogoutPage,
        meta: {
            title: 'Logout',
        },
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterPage,
        meta: {
            title: 'Register',
        },
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPasswordPage,
        meta: {
            title: 'Reset Password',
        },
    },
    {
        path: '/confirm-password-reset/:userId/:token',
        name: 'confirm-password-reset',
        component: ConfirmPasswordResetPage,
        meta: {
            title: 'Confirm Password Reset',
        },
        props: true,
    },
    {
        path: '/account',
        name: 'account',
        component: AccountPage,
        meta: {
            title: 'Account',
        },
    },
    {
        path: '/about',
        name: 'about',
        component: AboutPage,
        meta: {
            title: 'About',
        },
    },
    {
        path: '/organisations/:slug',
        name: 'organisation',
        component: OrganisationPage,
        props: true,
    },
    {
        path: '/organisations/:slug/admin',
        name: 'organisation-admin',
        component: OrganisationAdminPage,
        props: true,
    },
    {
        path: '/organisations/:slug/download-data',
        name: 'organisation-download-data',
        component: OrganisationDownloadDataPage,
        props: true,
    },
    {
        path: '/organisations/:slug/user-shifts/admin',
        name: 'organisation-user-shifts-admin',
        component: OrganisationUserShiftsAdminPage,
    },
    {
        path: '/organisations/:slug/users',
        name: 'organisation-users',
        component: OrganisationUsersAdmin,
    },
    {
        path: '/organisations/:slug/roles',
        name: 'organisation-roles',
        component: OrganisationRolesAdmin,
    },
    {
        path: '/organisations/:slug/users/:username',
        name: 'organisation-user',
        component: OrganisationUserAdmin,
    },
    {
        path: '/organisations/:slug/goodies/admin',
        name: 'organisation-goodies-admin',
        component: OrganisationGoodiesAdmin,
    },
    {
        path: '/organisations/:slug/user-goodies/admin',
        name: 'organisation-user-goodies-admin',
        component: OrganisationUserGoodiesAdmin,
    },
    {path: '/403', name: 'forbidden', component: ForbiddenPage, meta: {title: 'Forbidden'}},
    {path: '/403', name: 'not-found', component: NotFoundPage, meta: {title: 'Not Found'}},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// This callback runs before each route change
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'MyCrew';
    next();
})

export default router